function triggerWelcomeModal() {
  const now = new Date();
  const modal = document.querySelector('.js-modal-welcome');

  if (!modal) return false;

  modal.addEventListener('wheel', (event) => {
    event.stopPropagation();
  });

  modal.addEventListener('touchmove', (event) => {
    event.stopPropagation();
  });

  const modalCloseElements = modal.querySelectorAll('.modal__close');
  const modalContainer = modal.querySelector('.modal__container');

  let lastDatePopupShowed;
  const lastDateStr = localStorage.getItem('lastDatePopupShowed');
  if (lastDateStr !== null) {
    lastDatePopupShowed = new Date(parseInt(lastDateStr, 10));
  }

  const displayHoursEl = document.getElementById('display_hours');
  let hours = parseInt(displayHoursEl ? displayHoursEl.textContent : '', 10);
  if (isNaN(hours)) {
    hours = 24;
  }

  if (hours === 0 || (!lastDatePopupShowed || (now - lastDatePopupShowed) >= (hours * 3600000))) {
    showModal();

    localStorage.setItem('lastDatePopupShowed', now.getTime());
  } else {
    console.log(now - lastDatePopupShowed);
  }
  
  closeModal()

  let scrollPosition = 0;

  function disableScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
  }

  function enableScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollPosition);
  }

  function showModal() {
    fadeIn(modal);
    modalContainer.classList.add('modal-active');
    disableScroll();
  }

  function closeModal() {
    modalCloseElements.forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        fadeOut(modal);
        modalContainer.classList.remove('modal-active');
        enableScroll()
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.modal__wrapper') && !e.target.closest('#modal-trigger') && modalContainer.classList.contains('modal-active')) {
        fadeOut(modal);
        modalContainer.classList.remove('modal-active');
        enableScroll()
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalContainer.classList.contains('modal-active')) {
        fadeOut(modal);
        modalContainer.classList.remove('modal-active');
        enableScroll();
      }
    });
  }
}

export {
  triggerWelcomeModal,
};


function fadeIn(el, duration = 400) {
  el.style.opacity = 0;
  el.style.display = "block";
  let last = performance.now();

  function tick(now) {
    let delta = now - last;
    el.style.opacity = +el.style.opacity + delta / duration;
    last = now;
    if (+el.style.opacity < 1) {
      requestAnimationFrame(tick);
    }
  }

  requestAnimationFrame(tick);
}

function fadeOut(el, duration = 400) {
  el.style.opacity = 1;
  let last = performance.now();

  function tick(now) {
    let delta = now - last;
    el.style.opacity = +el.style.opacity - delta / duration;
    last = now;
    if (+el.style.opacity > 0) {
      requestAnimationFrame(tick);
    } else {
      el.style.display = "none";
    }
  }

  requestAnimationFrame(tick);
}
